import { AnimatedSprite, Application } from "pixi.js";

const TwoPI = 2 * Math.PI;

export type Fish = {
  sprite: AnimatedSprite;
  dx: number;
  dy: number;
};

export type FishDefinition = {
  sprite: () => Promise<AnimatedSprite>;
  attributes: {
    topSpeed: number;
    turnSpeed: number;
    acceleration: number;
    rarity: number;
  };
};

export const fish = async (
  app: Application,
  { sprite, attributes }: FishDefinition,
): Promise<Fish> => {
  const fish = {
    sprite: await sprite(),
    dx: 0,
    dy: 0,
  };

  let speed = 0;

  app.ticker.add((t) => {
    const targetRotation = (Math.PI + Math.atan2(fish.dy, fish.dx)) % TwoPI;

    if (fish.dx !== 0 || fish.dy !== 0) {
      fish.sprite.play();
      if (targetRotation !== fish.sprite.rotation) {
        let angleDiff = (fish.sprite.rotation - targetRotation) % TwoPI;
        if (angleDiff > Math.PI) {
          angleDiff = (TwoPI - angleDiff) * -1;
        }
        if (angleDiff < -Math.PI) {
          angleDiff = TwoPI + angleDiff;
        }

        let counterclockwise = false;
        if (angleDiff > 0) {
          counterclockwise = true;
        } else {
          counterclockwise = false;
        }

        const turn = 0.03 * attributes.turnSpeed;

        let nextRotation;
        if (!counterclockwise) {
          nextRotation = (TwoPI + (fish.sprite.rotation + turn)) % TwoPI;
        } else {
          nextRotation = (TwoPI + (fish.sprite.rotation - turn)) % TwoPI;
        }

        if (Math.abs(nextRotation - targetRotation) < turn) {
          nextRotation = targetRotation;
        }

        fish.sprite.rotation = nextRotation;
      }
    } else {
      fish.sprite.gotoAndStop(0);
    }
    const acc = 0.02 * attributes.acceleration;
    if (fish.sprite.rotation === targetRotation) {
      speed = Math.min(attributes.topSpeed, speed + acc);
    } else {
      speed = Math.max(0, speed - acc);
    }

    if (
      fish.sprite.rotation < Math.PI / 2 ||
      fish.sprite.rotation > (3 * Math.PI) / 2
    ) {
      fish.sprite.scale.y = Math.abs(fish.sprite.scale.y);
    } else {
      fish.sprite.scale.y = -1 * Math.abs(fish.sprite.scale.y);
    }

    fish.sprite.animationSpeed = speed / 10;

    fish.sprite.position.x +=
      Math.cos(fish.sprite.rotation) * speed * t.deltaTime;
    fish.sprite.position.y +=
      Math.sin(fish.sprite.rotation) * speed * t.deltaTime;
  });

  return fish;
};
